import React from 'react';
import styled from 'styled-components';

interface ImageProps {
    src: string;
    alt: string;
}

interface StyledImageProps {
    className: string;
    w: string;
    h: string;
}

const StyledImage = styled.div<Partial<StyledImageProps>>`
    width: ${({ w }) => w && `${w}`};
    height: ${({ h }) => h && `${h}`};

    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
`;

const Image: React.FC<ImageProps & Partial<StyledImageProps>> = ({ src, alt, className, w, h }) => (
    <StyledImage className={className} w={w} h={h} >
        <img src={src} alt={alt} />
    </StyledImage>
);

export default Image;